import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectTicketsListItems } from "../../../../../../redux/tickets/selector";
import { tickets } from "../../../../../../redux/tickets/action";
import { useNavigate } from "react-router-dom";
import { selectListItems } from "../../../../../../redux/library/selector";
import PageLoader from "../../../../../../components/PageLoader";

const ManagementTickets = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const libraryData = useSelector(selectListItems)
  const itemsData = useSelector(selectTicketsListItems)
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.OpenNetworkIssueGuid', headerName: 'OpenNetwork Issue Guid', sortable: false, filter: false },
      // { field: 'Message.OwnerType', headerName: 'Owner Type', sortable: false, filter: false },
      { field: 'Message.RequestorName', headerName: 'Requestor Name', sortable: false, filter: false },
      { field: 'Message.RequestorPhoneNo', headerName: 'Requestor PhoneNo', sortable: false, filter: false },
      { field: 'Message.IsOpenNetworkIssue', headerName: 'OpenNetworkIssue', cellRenderer: 'yesNoRenderer' },
      {
        field: 'Message.TicketStatusId',
        headerName: 'Ticket Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.TicketStatus }
      },
      {
        field: 'Message.TicketPriorityId',
        headerName: 'Ticket Priority',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.TicketPriority }
      },
      { field: 'Message.Category', headerName: 'Category', },
      { field: 'Message.Subject', headerName: 'Subject' },
      { field: 'Message.CreatedOnUtc', headerName: 'CreatedDate', isDateValueFormat: true },
      { field: 'Message.ModifiedOnUtc', headerName: 'ModifiedDate', isDateValueFormat: true }
    ]);
  }

  const fetchTicketsList = () => {
    dispatch(tickets.list({
      url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets/list`,
      entity: 'tickets',
      jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleDelete = (data: any) => {
    dispatch(tickets.delete({
      url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets/delete`,
      entity: 'tickets',
      jsonData: {
        "Records": [
          {
            "Context": {},
            "Message": {
              "Id": data?.Message?.Id
            }
          }
        ]
      }
    })).then(() => {
      dispatch(tickets.list({
        url: `https://igm.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/service/cma/management/tickets/list`,
        entity: 'tickets',
        jsonData: {
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }));
    });
  }

  useEffect(() => {
    createColumnDefs()
    fetchTicketsList()
  }, [pageData, pageSize])

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  const additionButtons: any = [
    {
      name: 'Add Tickets',
      callback: () => handleAdd(),
    }
  ];

  return (
    <>
      {itemsData?.isLoading ? <PageLoader /> :
        <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData} onDelete={handleDelete}
          setPageSize={setPageSize} paginationData={itemsData?.result?.pagination} onEdit={handleEdit}
          additionButtons={additionButtons} headingName="Tickets" />
      }
    </>
  );
};

export default ManagementTickets;


